import api from "../api";
import { Mapping } from "../../models";
import { ApiException, CreateMappingRequest } from "../generated";
import { FailedToCreateMappingError, FailedToDeleteMappingError, FailedToGetMappingsError, UnauthorizedAccessError } from "../../errors";

export const adminService = {
    getMappings: async () => {
        try {
            const response = await api.mappingsAll();
            const model: Mapping[] = response.map(x => ({
                reportId: x.reportId ?? "",
                relativeUrl: x.relativeUrl ?? ""
            }));
            return model;
        } catch (error) {
            if ((error as ApiException)?.status === 403) {
                throw new UnauthorizedAccessError();
            }
            throw new FailedToGetMappingsError();
        }
    },

    createMapping: async (mapping: Mapping) => {
        try {
            await api.mappingsPOST(new CreateMappingRequest({
                reportId: mapping.reportId,
                relativeUrl: mapping.relativeUrl
            }));
        } catch (error) {
            throw new FailedToCreateMappingError();
        }
    },

    deleteMapping: async (relativeUrl: string) => {
        try {
            await api.mappingsDELETE(relativeUrl);
        } catch (error) {
            throw new FailedToDeleteMappingError();
        }
    }
};
